<script>
import store from '../../store';
import firebase from 'firebase';
//import router from '../../router';

export default {
  name: 'Profile',
  data() {
      return {
          userRef: {},
          currentPhoto: '',
          newBio: {
              photo: ''
          }
      }
  },
  props: {
    user: Object,
    title: String,
    signout: Function,
    claims: Object
  },
  computed: {
      dark() {
          return store.state.dark;
      }
  },
  mounted() {
    setTimeout(() => {
        this.fetchProfilePhoto();
    }, 2000);
  },
  methods: {
        fetchProfilePhoto() {
            var self = this;

            console.log('fetching photo...');

            firebase.firestore().collection("users").doc(self.claims.uid).get().then((doc) => {
                console.log("photo url: ", doc.data().photo);
                //console.clear();
                self.currentPhoto = doc.data().photo;
            });
        },
        handleProfileUpload(e) {
            console.log("...handling profile upload");

            var self = this;

            var file = e.target.files[0];

            var path = "Profiles/" + self.claims.uid + "/" + file.name;

            //create a storage ref
            var storageRef = firebase.storage().ref(path);

            //create db ref
            var userRef = firebase.firestore().collection("users").doc(self.claims.uid);

            //upload file
            var task = storageRef.put(file);

            //update progress bar
            task.on('state_changed', 
            
                function progress(snapshot) {
                    var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    //uploader.value = percentage;

                    if(percentage == 100) {
                        //uploader.style.background = "#66BB6A";
                        console.log('image upload complete');
                    }
                },
                function error(err) {
                    console.log('oopse...', err);
                },
                function complete() {
                    //console.log(storageRef.child(imgPath).getDownloadURL().getResults());

                    task.snapshot.ref.getDownloadURL().then((downloadURL) => {
                        console.log('File available at: ' + downloadURL);
                        userRef.update({
                            photo: downloadURL + ""
                        });
                        //e.target.parentElement.style.backgroundImage = "url(" + downloadURL + ")";
                        self.currentPhoto = downloadURL + "";
                    });
                }
            )
        },
  }
}
</script>

<template>
<div class="profile-container">
    <div class="card-top">
        <h4>{{title}}</h4>
        <button class="sign-out" @click="signout">Logout</button>
    </div>
    <div class="card-content">
        <div class="profile-content">
            <div 
                class="profile-photo" 
                :class="(!dark ? '' : 'profile-photo-dark')" 
                :style="(!currentPhoto ? '' : 'background-image: url(' + currentPhoto + ');')">
                
                <input type="file" class="profile-img-upload" @change="handleProfileUpload">
                <div class="profile-img-upload profile-overlay"></div>
            </div>
            <h2>{{claims.displayName}}</h2>
            <p>{{claims.email}}</p>
        </div>
        <div class="loader"></div>
    </div>
</div>
</template>

<style scoped lang="scss">
@import '../../assets/global-styles/variables.scss';

input[type="file"] {
    opacity: 0;
}

.profile-container {
    text-align: center;
    padding: $gap;
    //display: flex;
    height: calc(100% - 64px);

    .card-top {
        display: inline-flex;
        justify-content: space-between;
        width: 100%;
    }
}

h4 {
    line-height: 24px;
    margin: 0px;
}

h2 {
    color: black; 
    //margin-top: 0px;
}

p {
    margin: -6px 0px;
}

.sign-out {
    background: transparent;
    color: black;
    border: black 2px solid;
    padding: 3px 6px 3px 6px;
    transition: 300ms;
    font-weight: bold;

    &:hover {
        background: black;
        color: white;
    }
}

.profile-img-upload {
    width: 124px;
    height: 124px;
    padding: 0px;
    margin: 0px;
    border-radius: 100%;
    cursor: pointer;

    &:hover {
        filter: brightness(0.6);
    }
}

.profile-photo {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 60px;
    height: 60px;
    cursor: pointer;
    transition: $animationSpeed;
    margin: auto;
    border-radius: 100%;
    z-index: 2;
    //filter: brightness(0.95);
    //box-shadow: $softerShadow;

    &:hover {
        filter: brightness(0.95);
    }
}

.profile-photo-dark {
    //background-image: url("../../assets/profile-dark.svg");

    &:hover {
        filter: brightness(0.95);
    }
}

.card-content {
    display: flex;
    margin-top: -24px;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.projects-count {
    width: 312px;
    height: 124px;
    margin-top: 80px;
    display: flex;
    justify-content: space-between;
    /*background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('../../assets/counts.svg');*/
    //transform: scale(1.1);

    .prof-box {
        display: flex;
        flex-direction: column;
        background: $colorBackdrop;
        width: 142px;
        height: 124px;
        border-radius: $rad;
    }

    .prof-box-dark {
        display: flex;
        flex-direction: column;
        background: $colorDarkMid;
        width: 142px;
        height: 124px;
        border-radius: $rad;
    }

    .count-title {
        text-align: left;
        font-size: 14px;
        padding-top: 18px;
        padding-left: 18px;
        width: 18px;
        opacity: 0.4;
    }

    .count-val {
        text-align: left;
        padding-left: 18px;
        margin-bottom: 0px;
        margin-top: auto;
        margin-bottom: 18px;
    }
}

.loader {
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #000000; /* Black */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 2.5s linear infinite;
  position: absolute;
  margin: auto;
  top: -72px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: -1;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>